'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _v = require('uuid/v1');

var _v2 = _interopRequireDefault(_v);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _compose = require('../lib/compose');

var _compose2 = _interopRequireDefault(_compose);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _withToggle = require('../with-toggle');

var _withToggle2 = _interopRequireDefault(_withToggle);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$id = _ref.id,
      id = _ref$id === undefined ? (0, _v2.default)() : _ref$id,
      opened = _ref.opened,
      closed = _ref.closed,
      toggled = _ref.toggled,
      onToggle = _ref.onToggle,
      classNames = _ref.classNames;
  return _react2.default.createElement(
    'div',
    { className: 'c11n-accordion ' + classNames.root },
    _react2.default.createElement(
      'button',
      {
        id: id + '-title',
        'aria-controls': id + '-body',
        'aria-expanded': toggled,
        'aria-label': title,
        className: classNames.head,
        onClick: onToggle
      },
      _react2.default.createElement(
        'div',
        { className: classNames.toggle },
        toggled ? opened : closed
      ),
      _react2.default.createElement(
        'div',
        { className: classNames.title },
        title
      )
    ),
    _react2.default.createElement(
      'div',
      {
        'aria-labelledby': id + '-title',
        role: 'region',
        id: id + '-body',
        hidden: !toggled,
        className: classNames.body
      },
      children
    )
  );
};

Accordion.propTypes = {
  /**
   * The content of the Accordion
   */
  children: _propTypes2.default.any.isRequired,

  /**
   * The title of the section
   */
  title: _propTypes2.default.any.isRequired,

  /**
   * The size of the gutter to be passed through rhythm
   */
  gutter: _propTypes2.default.number,

  /**
   * Add or remove the border to the accordion
   */
  border: _propTypes2.default.bool,

  /**
   * The color to apply to icon/border when active
   */
  color: _propTypes2.default.string,

  /**
   * The font treatment to be used for the title
   */
  font: _propTypes2.default.string,

  /**
   * Opens the accordion by default
   */
  toggled: _propTypes2.default.bool,

  /**
   * DOM ID
   */
  id: _propTypes2.default.string,

  /**
   * Icon to show when the panel is open
   */
  opened: _propTypes2.default.any,

  /**
   * Icon to show when the panel is closed
   */
  closed: _propTypes2.default.any,

  /**
   * Custom styles be applied { root, head, title, body }
   */
  styles: _propTypes2.default.object
};

Accordion.defaultProps = {
  gutter: 1,
  border: true,
  color: 'primary',
  font: 'head',
  opened: _react2.default.createElement(_icon2.default, { name: 'minus' }),
  closed: _react2.default.createElement(_icon2.default, { name: 'plus' }),
  styles: {}
};

exports.default = (0, _compose2.default)(_withToggle2.default, (0, _withStyles2.default)(_styles2.default))(Accordion);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/accordion/index.js
// module id = 826
// module chunks = 0